var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-update-parameters animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _vm.$store.getters.roleID === "4"
              ? _c("b-card", [
                  _c("h1", { staticClass: "lbv-page-title updateParameters" }, [
                    _vm._v("\n          Devices Matlab Parameters\n        "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "updateParametersInputs" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section",
                        staticStyle: {
                          "margin-top": "20px",
                          "min-height": "100px",
                        },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "header" },
                          [
                            _c(
                              "b-col",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  "margin-top": "10px",
                                },
                                attrs: { cols: "12" },
                              },
                              [
                                _c("h3", { staticClass: "form-label" }, [
                                  _vm._v(
                                    "\n                  Description\n                "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n              This page is provided so that you can update matlab parameters on device. Those will be sent to matlab with temperature log payload to calculate leak. Any action will trigger automatic updates on other sections\n              "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            'LeakBot section:\n              - LeakBot id - populate to display list of parameters of device in "Device parameters" section\n              '
                          ),
                          _c("br"),
                          _vm._v(
                            '- Filter by parameter name - filter the device parameter list by name of parameter (case sensitive) in "Device parameters" section\n              '
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v("Parameters section:\n              "),
                          _c("br"),
                          _vm._v(
                            '- Filter "Parameter Name" list - filters "Parameter Name" list \n              '
                          ),
                          _c("br"),
                          _vm._v(
                            "- Parameter Name - select parameter to be updated on device\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "- Parameter Value - populate value to update device. If parameter is array of values just pass parameters separated by comma e.g. 2, 3.5, 21 (no need to add brackets e.g. [2, 3.5, 21])\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            '- Update device - triggers update of parameter on device. Automatically updates "Device parameters" section\n              '
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v("Device parameters section:\n              "),
                          _c("br"),
                          _vm._v(
                            '- When you click on any row of available parameters of device the "Parameters" section will get populated automatically\n            '
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.updateDevice.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "push-down" },
                          [
                            _c("b-col", { attrs: { cols: "6" } }, [
                              _c(
                                "div",
                                { staticClass: "section" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "header" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            "margin-top": "10px",
                                          },
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "h3",
                                            { staticClass: "form-label" },
                                            [
                                              _vm._v(
                                                "\n                        LeakBot\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "push-down" },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "form-label" },
                                          [_vm._v("LeakBot id:")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "8" } }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.leakbotId,
                                              expression: "leakbotId",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.leakbotId },
                                          on: {
                                            change: _vm.leakbotIdChange,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.leakbotId =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "push-down" },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c("label", [
                                          _vm._v("Filter by parameter name:"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "8" } }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.filterParameterName,
                                              expression: "filterParameterName",
                                            },
                                          ],
                                          staticClass:
                                            "form-control full-width",
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.filterParameterName,
                                          },
                                          on: {
                                            input: [
                                              function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.filterParameterName =
                                                  $event.target.value
                                              },
                                              _vm.filterName,
                                            ],
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "6" } }, [
                              _c(
                                "div",
                                { staticClass: "section" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "header" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            "margin-top": "10px",
                                          },
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "h3",
                                            { staticClass: "form-label" },
                                            [
                                              _vm._v(
                                                "\n                        Parameters\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "push-down" },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c("label", [
                                          _vm._v(
                                            'Filter "Parameter Name" list:'
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "8" } }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.filterParameterNameList,
                                              expression:
                                                "filterParameterNameList",
                                            },
                                          ],
                                          staticClass:
                                            "form-control full-width",
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.filterParameterNameList,
                                          },
                                          on: {
                                            input: [
                                              function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.filterParameterNameList =
                                                  $event.target.value
                                              },
                                              _vm.changeFilterParameterNameList,
                                            ],
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "push-down" },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "form-label" },
                                          [_vm._v("Parameter Name:")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "8" } }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.matlabParameterName,
                                                expression:
                                                  "matlabParameterName",
                                              },
                                            ],
                                            staticClass:
                                              "form-control full-width",
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.matlabParameterName =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                                _vm.matlabParameterChange,
                                              ],
                                            },
                                          },
                                          _vm._l(
                                            _vm.matlabParameterList,
                                            function (parameter) {
                                              return _c(
                                                "option",
                                                {
                                                  key: parameter.parameter_name,
                                                  domProps: {
                                                    value: {
                                                      name: parameter.parameter_name,
                                                      type: parameter.parameter_type,
                                                      min: parameter.min,
                                                      max: parameter.max,
                                                      default:
                                                        parameter.default,
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        parameter.parameter_name
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "push-down" },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c("label", [
                                          _vm._v("Parameter Value:"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "8" } }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.matlabParameterValue,
                                              expression:
                                                "matlabParameterValue",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.matlabParameterValue,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.matlabParameterValue =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "push-down" },
                                    [
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c("label", [
                                          _vm._v(
                                            "Min val: " +
                                              _vm._s(
                                                _vm.matlabParameterName.min
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c("label", [
                                          _vm._v(
                                            "Max val: " +
                                              _vm._s(
                                                _vm.matlabParameterName.max
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "4" } }, [
                                        _c("label", [
                                          _vm._v(
                                            "Def val: " +
                                              _vm._s(
                                                _vm.matlabParameterName.default
                                              )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass: "push-down",
                                      staticStyle: {
                                        position: "absolute",
                                        bottom: "20px",
                                        right: "35px",
                                      },
                                    },
                                    [
                                      _c("b-col", { attrs: { cols: "12" } }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary parameterUpdate",
                                            attrs: { type: "submit" },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Update device"),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "section",
                            staticStyle: { "margin-top": "20px" },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "header" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "margin-top": "10px",
                                    },
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c("h3", { staticClass: "form-label" }, [
                                      _vm._v(
                                        "\n                    Device parameters\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                striped: "",
                                hover: "",
                                items: _vm.deviceParameterList,
                                fields: _vm.fields,
                              },
                              on: { "row-clicked": _vm.myRowClickHandler },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }